import { Controller } from "@hotwired/stimulus";

/**
 * ツールチップの表示・非表示を制御する
 *
 * @example
 * <div class="tooltip" role="tooltip" data-controller="tooltip-visibility">
 */
export default class extends Controller {
  show() {
    this.element.classList.add("show");
  }

  hide() {
    this.element.classList.remove("show");
  }
}
